/**
 * Utility function to dynamically load CSS files from public/styles/
 */

export const loadCSS = (cssFileName) => {
  // Check if the CSS is already loaded
  const existingLink = document.querySelector(`link[href*="${cssFileName}"]`);
  if (existingLink) {
    return; // Already loaded
  }

  // Create and append the link element
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = `${process.env.PUBLIC_URL || ''}/styles/${cssFileName}`;
  
  // Add to head
  document.head.appendChild(link);
};

export const unloadCSS = (cssFileName) => {
  const existingLink = document.querySelector(`link[href*="${cssFileName}"]`);
  if (existingLink) {
    existingLink.remove();
  }
};